import { getSrcs } from '@helpers/image';
import { Device, until } from '@helpers/media';
import { ReactComponent as SvgChevronLeft } from '@img/icons/chevron-left.svg';
import imgDistanceMarker from '@img/icons/distance-marker.png';
import { ReactComponent as SvgChevron } from '@img/icons/nav-arrow-right.svg';
import { ReactComponent as SvgPhone } from '@img/icons/phone.svg';
import { locations } from '@redux/slices/locations';
import { useAppDispatch, useAppSelector } from '@redux/store';
import CtaLink from '@stories/Components/CtaLink/CtaLink';
import * as React from 'react';
import S from './DetailPanel.styles';
const DetailPanel = () => {
    const dispatch = useAppDispatch();
    const state = useAppSelector((state) => state.locations);
    const selectedItem = state.apiData?.items.find((item) => item.id === state.selectedLocationId);
    if (!selectedItem) {
        return null;
    }
    const srcs = getSrcs(selectedItem.image, 767, 375, 6, 171 / 258);
    return (React.createElement(S.Container, null,
        React.createElement(S.BackWrapper, null,
            React.createElement(S.BackButton, { type: "button", onClick: (event) => {
                    event.preventDefault();
                    dispatch(locations.actions.deselectLocation());
                } },
                React.createElement(S.BackIcon, { as: SvgChevronLeft }),
                "Return to List")),
        React.createElement(S.ContentWrapper, null,
            selectedItem.distance && (React.createElement(S.Distance, null,
                React.createElement("img", { alt: "", loading: "lazy", role: "presentation", src: imgDistanceMarker }),
                React.createElement("span", null, `${selectedItem.distance} miles`))),
            React.createElement(S.Name, null, selectedItem.name),
            React.createElement(S.BlockGrid, null,
                selectedItem.openingHours && (React.createElement(S.Block, { "data-layout": "full" },
                    React.createElement(S.BlockTitle, null, "Opening Hours"),
                    React.createElement(S.BlockValue, { dangerouslySetInnerHTML: { __html: selectedItem.openingHours.join('<br>') } }))),
                !!selectedItem.address.length && (React.createElement(S.Block, { "data-layout": "half" },
                    React.createElement(S.BlockTitle, null, "Address"),
                    React.createElement(S.BlockValue, { dangerouslySetInnerHTML: { __html: selectedItem.address.join('<br>') } }),
                    React.createElement(S.BlockLink, { href: getDirectionsLink(selectedItem), target: "_blank" },
                        React.createElement("span", null, "Get Directions"),
                        React.createElement(SvgChevron, null)))),
                !!selectedItem.showing.length && (React.createElement(S.Block, { "data-layout": "half" },
                    React.createElement(S.BlockTitle, null, "Showing"),
                    React.createElement(S.BlockValue, null, selectedItem.showing.map((item) => (React.createElement(S.BlockValueLine, { key: item }, item)))))),
                selectedItem.telephone && (React.createElement(S.Block, { "data-layout": "full" },
                    React.createElement(S.BlockTitle, null, "Telephone"),
                    React.createElement(S.BlockLinkAlt, { href: `tel:${selectedItem.telephone}` },
                        React.createElement(SvgPhone, null),
                        React.createElement("span", null, selectedItem.telephone))))),
            React.createElement(CtaLink, { href: selectedItem.url, size: "small" }, "View Showroom Details")),
        React.createElement(S.ImageWrapper, null,
            React.createElement(S.Image, { role: "presentation", sizes: `${until(Device.Tablet)} 100vw, 300px`, src: srcs[0].split(' ')[0], srcSet: srcs.join(',') }))));
    function getDirectionsLink(item) {
        return `https://www.google.com/maps/dir/?api=1&destination=${item.address.join(',')}`;
    }
};
export default DetailPanel;
